import { ref, computed, watch, type Ref } from 'vue'
import { isMatch } from 'date-fns'
import type { Validate } from '@/shared/types/validation.types'

export type ValidationRule = 'email' | 'date'

export const isRequired = (value?: string): boolean => !value || value.length === 0

export const isMaxLength = (max: number, value?: string): boolean =>
  value && value.length <= max ? true : false

export const isEmail = (value?: string): boolean => {
  if (!value && !value?.length) return false

  const pattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/g
  return !pattern.test(value)
}

export const useValidation = (
  model: Ref<string | undefined>,
  type?: ValidationRule,
  required?: boolean,
  max?: number,
  emitValidation?: (validation: Validate) => void,
) => {
  const validation = ref<Validate>({
    isInvalid: false,
    isDirty: false,
  })

  const isInvalid = computed(() => {
    if (required && isRequired(model.value)) return true
    if (max && isMaxLength(max, model.value)) return true
    if (type === 'email' && isEmail(model.value)) return true
    if (type === 'date' && model?.value && !isMatch(model.value, 'P')) return true
    return false
  })

  watch(
    () => model.value,
    () => {
      validation.value.isInvalid = isInvalid.value
      emitValidation?.(validation.value)
    },
    { immediate: true },
  )

  const markDirty = () => {
    validation.value.isDirty = true
    emitValidation?.(validation.value)
  }

  return {
    validation,
    isInvalid,
    markDirty,
  }
}
